import { TrustApiError } from '../errors';
import { ApiRequestBody, ApiRequestHeaders, ApiRequestParams, ApiResponseError } from '../types';

import { buildUrl, decodeResponse, encodeRequest } from './url';

const XHR_STATUS_DONE = 4;

const responseByStatus = (status: number) => {
    if (status >= 500) {
        return {
            status: 'error',
            description: `${500}: Server error`,
        } as ApiResponseError;
    }

    if (status < 200 || (status >= 300 && status < 400)) {
        return {
            status: 'error',
            description: 'Unsupported status',
        } as ApiResponseError;
    }

    return null;
};

interface IRequestParams {
    method: 'GET' | 'POST';
    url: string;
    body?: ApiRequestBody;
    params?: ApiRequestParams;
    contentType?: string | null;
    headers?: ApiRequestHeaders;
}

// eslint-disable-next-line max-params
export const request = <T>({
    method,
    url,
    body,
    params,
    contentType = 'application/x-www-form-urlencoded',
    headers, // eslint-disable-next-line max-statements
}: IRequestParams): Promise<T> =>
    new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.open(method, buildUrl(url, params), true);
        xhr.withCredentials = true;

        if (contentType) {
            xhr.setRequestHeader('Content-Type', contentType);
        }

        if (headers) {
            Object.keys(headers).forEach((header) => {
                xhr.setRequestHeader(header, headers[header]!);
            });
        }

        xhr.addEventListener('load', () => {
            if (xhr.readyState === XHR_STATUS_DONE) {
                const res = responseByStatus(xhr.status) || decodeResponse<T>(xhr.responseText);

                return res.status === 'error' ? reject(new TrustApiError(res.description)) : resolve(res);
            }
        });

        xhr.addEventListener('error', () => {
            reject(new TrustApiError('Invalid response'));
        });

        if (method === 'POST' && body) {
            xhr.send(encodeRequest(body));
        } else {
            xhr.send();
        }
    });
